export type IfBulkUpdateTicketsRequest = {
  ifAttrInptInfoList: IfAttrInptInfo[];
  evntGrpTypeCd: string;
  dfnSetVerNum: string;
};
export type IfAttrInptInfo = {
  index: Number;
  tcktId: string;
  ifReqId: string;
  dipByRgn: string;
  cpntId: string;
  cmnt?: string;
  updateDateTime?: string;
};
